/**
 * Created by lihanying on 2017/7/6.
 */
import { GETPAYMENTLIST, GETBUSINESS, GETPERIOD, GETRECORDDETAIL } from './constants'

const initState = {}

export default function (state = initState, action) {
  switch (action.type) {
    case GETPAYMENTLIST:
      return Object.assign({}, state, { paymentList: action.payload })
    case GETBUSINESS:
      return Object.assign({}, state, { business: action.payload })
    case GETPERIOD:
      return Object.assign({}, state, { period: action.payload })
    case GETRECORDDETAIL:
      return Object.assign({}, state, { recordDetail: action.payload })

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/containers/Consume/reduce.js